import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export function ControlledTextField(props) {
    return (
        <Controller
            control={props.control}
            name={props.name}
            render={({ field }) => (
                <TextField {...field} fullWidth label={props.label} size="small" {...props.props} />
            )}
        />
    );
}
